// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__VMkWR","alertIcon":"ConfirmModal_alertIcon__1MitY"};